import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { RecordActionTypes } from 'store/actions/record.action';
var initialState = {
    loading: [],
    records: null,
    individualRecord: undefined,
    corporateRecord: undefined,
    crpRoles: undefined,
    err: undefined,
    otherData: null,
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case RecordActionTypes.GET_RECORDS_SUCCESS: {
            return tslib_1.__assign({}, state, { records: action.payload, loading: clearLoading(state, RecordActionTypes.GET_RECORDS) });
        }
        case RecordActionTypes.GET_RECORDS_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, RecordActionTypes.GET_RECORDS) });
        }
        case RecordActionTypes.GET_INDIVIDUAL_RECORD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.GET_INDIVIDUAL_RECORD_SUCCESS: {
            return tslib_1.__assign({}, state, { individualRecord: action.payload, loading: clearLoading(state, RecordActionTypes.GET_INDIVIDUAL_RECORD) });
        }
        case RecordActionTypes.GET_INDIVIDUAL_RECORD_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, RecordActionTypes.GET_INDIVIDUAL_RECORD) });
        }
        case RecordActionTypes.GET_CORPORATE_RECORD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.GET_CORPORATE_RECORD_SUCCESS: {
            return tslib_1.__assign({}, state, { corporateRecord: action.payload, loading: clearLoading(state, RecordActionTypes.GET_CORPORATE_RECORD) });
        }
        case RecordActionTypes.GET_CORPORATE_RECORD_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, RecordActionTypes.GET_CORPORATE_RECORD) });
        }
        case RecordActionTypes.GET_PRIMARY_CRP_RECORD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.CLEAR_GET_PRIMARY_CRP_RECORD: {
            return tslib_1.__assign({}, state, { individualRecord: null, corporateRecord: null, loading: clearLoading(state, RecordActionTypes.GET_PRIMARY_CRP_RECORD) });
        }
        case RecordActionTypes.ADD_CRP_ROLE: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.ADD_CRP_ROLE_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, RecordActionTypes.ADD_CRP_ROLE) });
        }
        case RecordActionTypes.DELETE_CRP: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.DELETE_CRP_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RecordActionTypes.DELETE_CRP) });
        }
        case RecordActionTypes.DELETE_CRP_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, RecordActionTypes.DELETE_CRP) });
        }
        case RecordActionTypes.DELETE_ROLE: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.DELETE_ROLE_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RecordActionTypes.DELETE_ROLE) });
        }
        case RecordActionTypes.DELETE_ROLE_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, RecordActionTypes.DELETE_ROLE) });
        }
        case RecordActionTypes.GET_CRP_ROLES: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.GET_CRP_ROLES_SUCCESS: {
            return tslib_1.__assign({}, state, { crpRoles: action.payload, loading: clearLoading(state, RecordActionTypes.GET_CRP_ROLES) });
        }
        case RecordActionTypes.GET_CRP_ROLES_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, RecordActionTypes.GET_CRP_ROLES) });
        }
        case RecordActionTypes.RESET_RECORD: {
            return Object.assign({}, initialState);
        }
        case RecordActionTypes.GET_OTHER_DATA: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case RecordActionTypes.GET_OTHER_DATA_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RecordActionTypes.GET_OTHER_DATA), otherData: action.payload });
        }
        case RecordActionTypes.GET_OTHER_DATA_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RecordActionTypes.GET_OTHER_DATA), err: action.payload });
        }
        default: {
            return state;
        }
    }
}
var record = function (state) { return state.record; };
var ɵ0 = record;
var ɵ1 = function (state) { return state.loading; }, ɵ2 = function (state) { return state.records; }, ɵ3 = function (state) { return state.individualRecord; }, ɵ4 = function (state) { return state.corporateRecord; }, ɵ5 = function (state) { return state.crpRoles; }, ɵ6 = function (state) { return state.err; }, ɵ7 = function (state) { return state.otherData; };
export var Selectors = {
    getLoading: createSelector(record, ɵ1),
    getRecords: createSelector(record, ɵ2),
    getIndividualRecord: createSelector(record, ɵ3),
    getCorporateRecord: createSelector(record, ɵ4),
    getCrpRoles: createSelector(record, ɵ5),
    getErrors: createSelector(record, ɵ6),
    getRecordOtherData: createSelector(record, ɵ7),
};
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
